module.exports = __webpack_public_path__ + "static/img/4.53458d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/4.png
// module id = ja7V
// module chunks = 0